// extracted by mini-css-extract-plugin
module.exports = {"text":"text-bold-m_text__3BUij"};